module.exports = __webpack_public_path__ + "static/media/plus.b8291ad2.svg";